import React from 'react'
import { SVGProps } from 'react'

const QuotationMarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.9875 4.5H0.9375C0.419678 4.5 0 4.91968 0 5.4375V17.4875C0 18.0054 0.419678 18.425 0.9375 18.425H6.0249V26.5251C6.0249 27.0427 6.44458 27.4626 6.9624 27.4626H9.9751C10.3787 27.4626 10.7368 27.2043 10.8643 26.8215L13.8767 17.7839C13.9087 17.6885 13.925 17.5884 13.925 17.4875V5.4375C13.925 4.91968 13.5054 4.5 12.9875 4.5Z" />
    <path d="M31.0627 4.5H19.0127C18.4949 4.5 18.0752 4.91968 18.0752 5.4375V17.4875C18.0752 18.0054 18.4949 18.425 19.0127 18.425H24.1003V26.5251C24.1003 27.0427 24.52 27.4626 25.0378 27.4626H28.0503C28.4539 27.4626 28.812 27.2043 28.9397 26.8215L31.9521 17.7839C31.9839 17.6885 32.0002 17.5884 32.0002 17.4875V5.4375C32.0002 4.91968 31.5806 4.5 31.0627 4.5Z" />
  </svg>
)
export default QuotationMarkIcon
